var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('j-modal',{attrs:{"title":"选择","size":"normal","visible":_vm.visible},on:{"ok":_vm.handleOk,"cancel":_vm.handleCancel}},[_c('UserManage',{ref:"userManage",attrs:{"isModal":true,"isMulti":_vm.params.isMulti}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }